import { render, staticRenderFns } from "./EducationEntryAwards.vue?vue&type=template&id=feadb052&"
import script from "./EducationEntryAwards.vue?vue&type=script&lang=js&"
export * from "./EducationEntryAwards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports